import React from 'react'
import { Box, BoxProps } from '@mui/material'
import { Link } from 'react-router-dom'

interface LogoProps extends BoxProps {
  colorless?: boolean
}

const Logo: React.FC<LogoProps> = ({ colorless = false, sx }) => {
  return (
    <Box sx={{ display: 'inline-flex', ...sx }}>
      <Link to={'/'}>
        {!colorless ? (
          <img src={'/images/logo-full.png?version=1.0'} alt="PMT" />
        ) : (
          <img src={'/images/logo-white.png?version=1.0'} alt="PMT" />
        )}
      </Link>
    </Box>
  )
}

export default Logo
